import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { AuthGuard } from './guard/auth.guard';
import { HomeComponent } from './home/home.component';
import { DefaultComponent } from './layout/default/default.component';
import { InnerpageComponent } from './layout/innerpage/innerpage.component';
import { ProfileComponent } from './profile/profile.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { SignupCComponent } from './signup-c/signup-c.component';
import { SignupCoachComponent } from './signup-coach/signup-coach.component';
import { SignupComponent } from './signup/signup.component';
import { VideoLibraryComponent } from './video-library/video-library.component';
import { PaymentCancelComponent } from './payment-cancel/payment-cancel.component';
import { PaymentSuccessComponent } from './payment-success/payment-success.component';
import { InviteSignupComponent } from './invite-signup/invite-signup.component';
import { PlaylistVideosComponent } from './layout/shared/playlist-videos/playlist-videos.component';
import { PlaylistViewComponent } from './playlist-view/playlist-view.component';
import { AdminComponent } from './layout/admin/admin.component';
import { LoginComponent } from './Admin/login/login.component';
import { AdminsignupComponent } from './Admin/adminsignup/adminsignup.component';
import { AdminForgotPasswordComponent } from './Admin/admin-forgot-password/admin-forgot-password.component';
import { AdminDashboardComponent } from './Admin/admin-dashboard/admin-dashboard.component';
import { AdminAuthGuard } from './guard/admin-auth.guard';
import { UsersComponent } from './Admin/users/users.component';
import { RulesComponent } from './Admin/rules/rules.component';
import { SkillsComponent } from './Admin/skills/skills.component';
import { OptionsComponent } from './Admin/options/options.component';
import { ChoicesComponent } from './Admin/choice/choices.component';
import { LevelsComponent } from './Admin/levels/levels.component';
import { CategoriesComponent } from './Admin/categories/categories.component';
import { VideosComponent } from './Admin/videos/videos.component';
import { SubscriptionsComponent } from './Admin/subscriptions/subscriptions.component';
import { SchoolcoachComponent } from './schoolcoach/schoolcoach.component';
import { PlansComponent } from './plans/plans.component';
import { NonauthGuard } from './guard/nonauth.guard';
import { InstructorsComponent } from './Admin/instructors/instructors.component';
import { SignatureseriesComponent } from './Admin/signatureseries/signatureseries.component';
import { SeriesvideosComponent } from './Admin/seriesvideos/seriesvideos.component';
import { MessageComponent } from './Admin/message/message.component';
import { SeriespageComponent } from './layout/seriespage/seriespage.component';
import { SeriesComponent } from './series/series.component';
import { SeriesviewComponent } from './seriesview/seriesview.component';
import { SeriesinnerComponent } from './layout/seriesinner/seriesinner.component';

const routes: Routes = [
  {
    path: "",
    component: DefaultComponent,
    children: [{ 
        path : "",
        component: HomeComponent
      }
      // , {
      //   path: "test", 
      //   component: HomeComponent // contactComponent E.g
      // }
    ]
  },
  {
    path: "",
    component: InnerpageComponent,
    children: [{ 
      path : "video",
      component: VideoLibraryComponent,
      canActivate: [AuthGuard]
    },{ 
      path : "pricing",
      component: PlansComponent,
      canActivate: [NonauthGuard]
    }]
  },
  {
    path: "",
    component: InnerpageComponent,
    children: [
      { 
        path : "profile",
        component: ProfileComponent,
        canActivate: [AuthGuard]
      },
      { 
        path : "schoolcoach",
        component: SchoolcoachComponent,
        canActivate: [NonauthGuard]
      },
      { 
        path : "playlist/:slug",
        component: PlaylistViewComponent,
        canActivate: [AuthGuard]
      },{ 
        path : "signup",
        component: SignupComponent,
        canActivate: [NonauthGuard]
      },
      // { 
      //   path : "signup-coach",
      //   component: SignupCoachComponent,
      //   canActivate: [NonauthGuard]
      // },{ 
      //   path : "signup-choreographer",
      //   component: SignupCComponent,
      //   canActivate: [NonauthGuard]
      // },
      { 
        path : "forgot-password",
        component: ForgotPasswordComponent
      },{ 
        path : "payment-success",
        component: PaymentSuccessComponent
      },{ 
        path : "payment-cancelled",
        component: PaymentCancelComponent
      },{ 
        path : "dashboard",
        component: DashboardComponent,
        canActivate: [AuthGuard]
      },{
        path: "invitation", 
        component: InviteSignupComponent // contactComponent E.g
      }
    ]
  },
  {
    path: "series",
    component: SeriespageComponent,
    children: [{ 
      path : "",
      component: SeriesComponent
    }]
  },
  { 
    path : "series/:slug",
    component: SeriesinnerComponent,
    children: [{ 
      path : "",
      component: SeriesviewComponent,
      canActivate: [AuthGuard]
    }]
  },
  {
    path: "admin",
    component: AdminComponent,
    children: [{ 
      path : "",
      component: AdminDashboardComponent,
      canActivate: [AdminAuthGuard]
    },{ 
      path : "users",
      component: UsersComponent,
      canActivate: [AdminAuthGuard]
    },{ 
      path : "rules",
      component: RulesComponent,
      canActivate: [AdminAuthGuard]
    },{ 
      path : "levels",
      component: LevelsComponent,
      canActivate: [AdminAuthGuard]
    },{ 
      path : "skills",
      component: SkillsComponent,
      canActivate: [AdminAuthGuard]
    },{ 
      path : "instructors",
      component: InstructorsComponent,
      canActivate: [AdminAuthGuard]
    },{ 
      path : "signatureseries",
      component: SignatureseriesComponent,
      canActivate: [AdminAuthGuard]
    },{ 
      path : "seriesvideos",
      component: SeriesvideosComponent,
      canActivate: [AdminAuthGuard]
    },{ 
      path : "options",
      component: OptionsComponent,
      canActivate: [AdminAuthGuard]
    },{ 
      path : "option-choices",
      component: ChoicesComponent,
      canActivate: [AdminAuthGuard]
    },{ 
      path : "categories",
      component: CategoriesComponent,
      canActivate: [AdminAuthGuard]
    },{ 
      path : "videos",
      component: VideosComponent,
      canActivate: [AdminAuthGuard]
    },{ 
      path : "subscriptions",
      component: SubscriptionsComponent,
      canActivate: [AdminAuthGuard]
    },{ 
      path : "message",
      component: MessageComponent,
      canActivate: [AdminAuthGuard]
    },{ 
        path : "login",
        component: LoginComponent
      }
      // , {
      //   path: "signup", 
      //   component: AdminsignupComponent // contactComponent E.g
      // }
      ,{ 
        path : "forgot-password",
        component: AdminForgotPasswordComponent
      }]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{
    paramsInheritanceStrategy: 'always'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
